<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <!-- TITLE -->
  <div class="container-fluid p-0">
    <div style="background-color:#dc3545;color: white;text-align: center;padding: 5px;">
      <ul class="list-unstyled text-end">
        <li>
          <a *ngIf="currentLanguage !== 'en'" class="btn btn-warning btn-sm" (click)="switchLanguage('en')">English</a>
          <a *ngIf="currentLanguage !== 'mr'" class="btn btn-warning btn-sm" (click)="switchLanguage('mr')">मराठी</a>
        </li>
      </ul>
      <h1 class="text-center">{{ translate?.TITLE }}</h1>
      <p class="subtitle text-center">
        {{ translate?.SUBTITLE }}

      </p>
    </div>
  </div>



  
  <div class="container">
    <div style="border: red solid 5px; border-radius: 10px; padding: 20px; margin-bottom: 20px;">
      <!-- ================= SECTION A ================= -->

      <div class="mb-4 p-3 border rounded bg-light">

  <h5 class="fw-bold text-primary mb-2">
    {{ translate?.SECTION_A.OBJECTIVE_TITLE_EN }}
  </h5>

  <p class="mb-3 text-dark" style="text-align: justify;">
    {{ translate?.SECTION_A.OBJECTIVE_DESC_EN }}
  </p>

  <h5 class="fw-bold text-primary mb-2">
    {{ translate?.SECTION_A.OBJECTIVE_TITLE_MR }}
  </h5>

  <p class="mb-0 text-dark" style="text-align: justify;">
    {{ translate?.SECTION_A.OBJECTIVE_DESC_MR }}
  </p>

</div>
      <section class="section">
        <h2 class="eoi-exhibition">{{ translate?.SECTION_A.TITLE}}</h2>

        <div class="row px-3">

<div class="col-md-6">

  <mat-label class="fw-semibold mb-2 d-block">
    {{ translate?.SECTION_A.REGISTRATION_TYPE || 'Registration Type' }}
  </mat-label>

  <mat-radio-group
    formControlName="registrationType"
    class="d-flex gap-4 align-items-center"
    (change)="onRegistrationTypeChange()"
  >

    <mat-radio-button value="MSME">
      {{ translate?.SECTION_A.MSME_LABEL_REGISTRATION }}
    </mat-radio-button>

    <mat-radio-button value="ARTISAN">
      {{ translate?.SECTION_A.ARTISAN_LABEL_REGISTRATION }}
    </mat-radio-button>

  </mat-radio-group>

</div>
          <!-- <div class="col-md-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>{{ translate?.SECTION_A.NAME }}</mat-label>
              <input matInput (input)="onFirstNameInput($event)" formControlName="msmEName" (keypress)="allowEnglishAndNumbers($event)" (paste)="allowEnglishPaste($event)">
              <mat-error *ngIf="form.get('msmEName')?.hasError('required')">
                {{translate?.MSMENameRequired}}
              </mat-error>
            </mat-form-field>
          </div> -->
<div class="col-md-6" *ngIf="form.get('registrationType')?.value === 'MSME'">

  <mat-form-field appearance="outline" class="w-100">

    <mat-label>{{ translate?.SECTION_A.MSME_NAME }}</mat-label>

    <input matInput
           formControlName="msmeName"
           (input)="onFirstNameInput($event)"
           (keypress)="allowEnglishAndNumbers($event)"
           (paste)="allowEnglishPaste($event)">

    <!-- Required Error -->
    <mat-error *ngIf="form.get('msmeName')?.hasError('required') 
                      && (form.get('msmeName')?.touched || form.get('msmeName')?.dirty)">
      {{ translate?.MSMENameRequired }}
    </mat-error>

  </mat-form-field>

</div>
<div class="col-md-6" *ngIf="form.get('registrationType')?.value !== 'MSME'">

  <mat-form-field appearance="outline" class="w-100">

    <mat-label>{{ translate?.SECTION_A.ARTISAN_NAME }}</mat-label>

    <input matInput
           formControlName="artisanName"
           (input)="onFirstNameInput($event)"
           (keypress)="allowEnglishAndNumbers($event)"
           (paste)="allowEnglishPaste($event)">

    <!-- Required Error -->
    <mat-error *ngIf="form.get('artisanName')?.hasError('required') 
                      && (form.get('artisanName')?.touched || form.get('artisanName')?.dirty)">
      {{ translate?.ARTISANNameRequired }}
    </mat-error>

  </mat-form-field>

</div>

          <div class="col-md-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>{{ translate?.SECTION_A.AADHAR }}</mat-label>
              <input matInput maxlength="12" (keypress)="aadhaarKeyPress($event)" formControlName="aadhaarNumber" (paste)="allowEnglishPaste($event)">
              <mat-error *ngIf="form.get('aadhaarNumber')?.hasError('required')">
                {{translate?.AadhaarNumberRequired}}
              </mat-error>
              <mat-error *ngIf="form.get('aadhaarNumber')?.hasError('pattern')">
                {{translate?.AddharValidity}}
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-md-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>{{ translate?.SECTION_A.ORG_TYPE }}</mat-label>
              <mat-select formControlName="organizationTypeID">
                <mat-option *ngFor="let organizationType of organizationTypeList" [value]="organizationType.organizationTypeId">{{ organizationType.organizationTypeName }}</mat-option>
              </mat-select>
              <mat-error *ngIf="form.get('organizationTypeID')?.hasError('required')">
                {{translate?.OrganizationTypeRequired}}
              </mat-error>
            </mat-form-field>
          </div>

          <div class="col-md-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>{{ translate?.SECTION_A.YEAR }}</mat-label>

              <input matInput
                     type="number"
                     maxlength="4"
                     [max]="currentYear"
                     oninput="this.value=this.value.slice(0,4)"
                     formControlName="yearOfEstablishment"
                     (input)="limitYearLength($event)"
                     (keypress)="allowEnglishAndNumbers($event)"
                     (paste)="allowEnglishPaste($event)">

              <mat-error *ngIf="form.get('yearOfEstablishment')?.hasError('required')">
                {{ translate?.YearRequired }}
              </mat-error>

              <mat-error *ngIf="form.get('yearOfEstablishment')?.hasError('invalidYear')">
                {{translate?.InvalidYear}}
              </mat-error>

              <mat-error *ngIf="form.get('yearOfEstablishment')?.hasError('futureYear')">
                {{ translate?.FutureYearReuired }}
              </mat-error>
            </mat-form-field>
          </div>

   
          
          <!-- <div class="col-md-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>{{ translate?.SECTION_A.UDYAM }}</mat-label>
              <input matInput
                  [placeholder]="translate?.SECTION_A.UDYAM"
                     formControlName="udyamOrArtisanCardNo"
          
                     (keypress)="allowEnglishAndNumbers($event)"
                     (paste)="allowEnglishPaste($event)"
                     maxlength="20">

              <mat-error *ngIf="form.get('udyamOrArtisanCardNo')?.hasError('required')">
                {{ translate?.UdyamNoRequired }}
              </mat-error>
     
            </mat-form-field>
          </div> -->




<div class="col-md-6" *ngIf="form.get('registrationType')?.value === 'MSME'">

  <mat-form-field appearance="outline" class="w-100">

    <mat-label>{{ translate?.SECTION_A.UDYAM_NUMBER_LABEL }}</mat-label>

    <input matInput formControlName="udyamNumber"      (input)="onUdyamInput($event)"   maxlength="19">

    <mat-error *ngIf="form.get('udyamNumber')?.hasError('required')">
      {{ translate?.SECTION_A.UDYAM_NUMBER_REQUIRED }}
    </mat-error>

    <mat-error *ngIf="form.get('udyamNumber')?.hasError('pattern')">
      {{ translate?.SECTION_A.INVALID_UDYAM_FORMAT }}
    </mat-error>

  </mat-form-field>

</div>


<div class="col-md-6" *ngIf="form.get('registrationType')?.value !== 'MSME'">

  <mat-form-field appearance="outline" class="w-100">

    <mat-label>{{ translate?.SECTION_A.ARTISAN_NUMBER_LABEL }}</mat-label>

    <input matInput formControlName="artisanNumber" maxlength="20" >

    <mat-error *ngIf="form.get('artisanNumber')?.hasError('required')">
      {{ translate?.SECTION_A.ARTISAN_NUMBER_REQUIRED }}
    </mat-error>

  </mat-form-field>

</div>

          <!-- <div class="col-md-6">
            <label class="file-label">{{ translate?.SECTION_A.UDYAM_FILE }}*</label>

            <input type="file" formControlName="UdyamFile"
                   (change)="onPhotoChange($event)" class="form-control" />

            <mat-error *ngIf="form.get('UdyamFile')?.touched && form.get('UdyamFile')?.hasError('required')">
              <small>{{translate?.UdyamFileRequired}}</small>
            </mat-error>
          </div>  -->


          <div class="col-md-6">

  <!-- 🔹 Dynamic Label -->
  <label class="file-label">
    {{
      form.get('registrationType')?.value === 'MSME'
        ? (translate?.SECTION_A?.UDYAM_FILE + ' *')
        : (translate?.SECTION_A?.ARTISAN_FILE + ' *')
    }}
  </label>

  <!-- 🔹 File Input -->
  <input type="file"
         formControlName="UdyamFile"
         (change)="onPhotoChange($event)"
         class="form-control" />

  <!-- 🔹 Dynamic Error -->
  <mat-error *ngIf="form.get('UdyamFile')?.touched && form.get('UdyamFile')?.hasError('required')">
    <small>
      {{
        form.get('registrationType')?.value === 'MSME'
          ? translate?.UdyamFileRequired
          : translate?.ArtisanFileRequired
      }}
    </small>
  </mat-error>
  

</div>
          


          <!-- <div class="col-md-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>{{ translate?.SECTION_A.INDUSTRY }}</mat-label>
              <input matInput formControlName="industrySector" (keypress)="allowAddressChars($event)" (paste)="allowEnglishPaste($event)">
              <mat-error *ngIf="form.get('industrySector')?.hasError('required')">
                {{translate?.IndustrySectorRequired}}
              </mat-error>
            </mat-form-field>
          </div> -->
<!-- WHEN MSME SELECTED → SHOW DROPDOWN -->
<div class="col-md-6" *ngIf="registrationType === 'MSME'">

  <mat-form-field appearance="outline" class="w-100">
    <mat-label>{{ translate?.SECTION_A.INDUSTRY }}</mat-label>

    <mat-select formControlName="industrySectorSelect"
                (selectionChange)="onIndustryChange()">

      <mat-option value="Service">
        {{ translate?.SECTION_A.SERVICE }} 
      </mat-option>

      <mat-option value="Manufacturing">
        {{ translate?.SECTION_A.MANUFACTURING }} 
      </mat-option>

      <mat-option value="Trading">
        {{ translate?.SECTION_A.TRADING }} 
      </mat-option>

      <mat-option value="Other">
        {{ translate?.SECTION_A.OTHER }} 
      </mat-option>

    </mat-select>

    <mat-error *ngIf="form.get('industrySectorSelect')?.hasError('required')">
      {{ translate?.IndustrySectorRequired }}
    </mat-error>
  </mat-form-field>

</div>

<!-- SHOW "OTHER" FIELD -->
<div class="col-md-6"
     *ngIf="registrationType === 'MSME' &&
            form.get('industrySectorSelect')?.value === 'Other'">

  <mat-form-field appearance="outline" class="w-100">

    <mat-label>{{ translate?.SECTION_A.OTHER_INDUSTRY }}</mat-label>

    <input matInput
           formControlName="industrySectorOther"
           (keypress)="allowAddressChars($event)"
           (paste)="allowEnglishPaste($event)">

    <mat-error *ngIf="form.get('industrySectorOther')?.hasError('required')">
      {{ translate?.IndustrySectorRequired }}
    </mat-error>

  </mat-form-field>

</div>
<!-- WHEN NOT MSME → SHOW INPUT FIELD -->
<div class="col-md-6"  *ngIf="registrationType !== 'MSME'">

  <mat-form-field appearance="outline" class="w-100">
    <mat-label>{{ translate?.SECTION_A.INDUSTRY }}</mat-label>

    <input matInput
           formControlName="industrySector"
           (keypress)="allowAddressChars($event)"
           (paste)="allowEnglishPaste($event)">

    <mat-error *ngIf="form.get('industrySector')?.hasError('required')">
      {{ translate?.IndustrySectorRequired }}
    </mat-error>
  </mat-form-field>

</div>

          <!-- SOCIAL CATEGORY -->
          <div class="col-md-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>{{ translate?.SECTION_A.SOCIAL }}</mat-label>
              <mat-select formControlName="socialCategoryID">
                <mat-option *ngFor="let category of socialCategoryList" [value]="category.socialCategoryId">{{ category.socialCategoryName }}</mat-option>
              </mat-select>
              <mat-error *ngIf="form.get('socialCategoryID')?.hasError('required')">
                {{translate?.SocialCategoryReuired}}
              </mat-error>
            </mat-form-field>
          </div>

          <div class="col-md-6">
            <label class="file-label">{{ translate?.SECTION_A.CASTE_FILE }}*</label>
            <input type="file" formControlName="CasteFile" (change)="onPhotoChange($event)" class="form-control" />
            <mat-error *ngIf="form.get('CasteFile')?.touched && form.get('CasteFile')?.hasError('required')">
              <small>{{translate?.CasteFileRequired}}</small>
            </mat-error>
          </div>

          <!-- GENDER -->
          <!-- <div class="col-md-6">
            <div class="radio-group">
              <label class="radio-label">{{ translate?.SECTION_A.GENDER }}*</label>
              <mat-radio-group formControlName="gender" row>
                <mat-radio-button value="M">{{ translate?.GENDER.M }}</mat-radio-button>
                <mat-radio-button value="F">{{ translate?.GENDER.F }}</mat-radio-button>
                <mat-radio-button value="O">{{ translate?.GENDER.O }}</mat-radio-button>
              </mat-radio-group>

              <mat-error *ngIf="form.get('gender')?.touched && form.get('gender')?.hasError('required')">
                <small>{{translate?.GenderRequired}}</small>
              </mat-error>
            </div>
          </div> -->

          <div class="col-md-6">
  <div class="radio-group">

    <label class="radio-label">
      {{
        form.get('registrationType')?.value === 'MSME'
          ? (translate?.GENDER.GENDER_MSME)
          : (translate?.GENDER.GENDER_ARTISAN)
      }} *
    </label>

    <mat-radio-group formControlName="gender" row>
      <mat-radio-button value="M">
        {{ translate?.GENDER.M }}
      </mat-radio-button>

      <mat-radio-button value="F">
        {{ translate?.GENDER.F }}
      </mat-radio-button>

      <mat-radio-button value="O">
        {{ translate?.GENDER.O }}
      </mat-radio-button>
    </mat-radio-group>

    <mat-error *ngIf="form.get('gender')?.touched && form.get('gender')?.hasError('required')">
      <small>{{ translate?.GENDER.GENDER_REQUIRED }}</small>
    </mat-error>

    
      

  </div>
</div>
          <div class="col-md-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>{{ translate?.SECTION_A.ADDRESS }}</mat-label>
              <textarea matInput formControlName="registeredAddress" (keypress)="allowAddressChars($event)" (paste)="allowEnglishPaste($event)"></textarea>
              <mat-error *ngIf="form.get('registeredAddress')?.hasError('required')">
                {{translate?.AddressRequired}}
              </mat-error>
              <mat-error *ngIf="form.get('registeredAddress')?.hasError('pattern')">
                {{translate?.SpecialCharNotAllow}}
              </mat-error>
            </mat-form-field>
          </div>

          <div class="col-md-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>{{ translate?.SECTION_A.CITY }}</mat-label>
              <mat-select formControlName="districtID">
                <mat-option *ngFor="let district of districtList" [value]="district.districtId">{{ district.districtName }}</mat-option>
              </mat-select>
              <mat-error *ngIf="form.get('districtID')?.hasError('required')">
                {{translate?.DistrictRequired}}
              </mat-error>
            </mat-form-field>
          </div>

          <div class="col-md-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>{{ translate?.SECTION_A.STATE }}</mat-label>
              <input matInput value="Maharashtra" disabled>
            </mat-form-field>
          </div>

          <div class="col-md-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>{{ translate?.SECTION_A.PIN }}</mat-label>
              <input matInput maxlength="6" formControlName="pinCode" (keypress)="onlyNumbersWithFour($event)" (paste)="allowEnglishPaste($event)">
              <mat-error *ngIf="form.get('pinCode')?.hasError('required')">
                {{translate?.PinCodeRequired}}
              </mat-error>

              <mat-error *ngIf="form.get('pinCode')?.hasError('pattern')">
                {{translate?.EnterValidPinCode}}
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </section>

      <!-- ================= SECTION B ================= -->
      <section class="section">
        <h2 class="eoi-exhibition">{{ translate?.SECTION_B.TITLE}}</h2>

        <div class="row px-3">
          <div class="col-md-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>{{ translate?.SECTION_B.CONTACT_NAME }}</mat-label>
              <input matInput (input)="onContactPersonInput($event)" formControlName="contactPersonName" (keypress)="allowEnglishAndNumbers($event)" (paste)="allowEnglishPaste($event)">
              <mat-error *ngIf="form.get('contactPersonName')?.hasError('required')">
                {{translate?.ContactPersonNameRequired}}
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-md-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>{{ translate?.SECTION_B.DESIGNATION }}</mat-label>
              <input matInput (input)="onDesignationNameInput($event)" formControlName="designation" (keypress)="allowEnglishAndNumbers($event)" (paste)="allowEnglishPaste($event)">
              <mat-error *ngIf="form.get('designation')?.hasError('required')">
                {{translate?.DesignationRequired}}
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-md-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>{{ translate?.SECTION_B.MOBILE }}</mat-label>
              <input matInput formControlName="mobileNumber" maxlength="10" (keypress)="onlyMobileNumber($event)" (paste)="allowEnglishPaste($event)">
              <mat-error *ngIf="form.get('mobileNumber')?.hasError('required')">
                {{translate?.MobileNumberRequired}}
              </mat-error>

              <mat-error *ngIf="form.get('mobileNumber')?.hasError('pattern')">
                {{translate?.MobileValidity}}
              </mat-error>
            </mat-form-field>
          </div>

          <div class="col-md-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>{{ translate?.SECTION_B.ALT_MOBILE }}</mat-label>
              <input matInput formControlName="alternateMobileNumber" maxlength="10" (keypress)="onlyMobileNumber($event)" (paste)="allowEnglishPaste($event)">
              <!-- <mat-error *ngIf="form.get('alternateMobileNumber')?.hasError('required')">
                {{translate?.AlternateMobileNumberRequired}}
              </mat-error> -->
              <mat-error *ngIf="form.get('alternateMobileNumber')?.hasError('pattern')">
                {{translate?.AlternateMobileValidity}}
              </mat-error>
            </mat-form-field>
          </div>

          <div class="col-md-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>{{ translate?.SECTION_B.EMAIL }}</mat-label>
              <input matInput formControlName="emailAddress">
              <mat-error *ngIf="form.get('emailAddress')?.hasError('required')">
                {{translate?.EmailRequired}}
              </mat-error>

              <mat-error *ngIf="form.get('emailAddress')?.hasError('pattern')">
                {{translate?.ValidEmail}}
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </section>

      <!-- ================= SECTION C ================= -->
      <section class="section">
        <h2 class="mat-headline-6 eoi-exhibition">
          {{ translate?.SECTION_C.TITLE }}
        </h2>


        <div class="row px-3">
          <div class="col-m-12">
            <!-- Product / Service Description -->
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>{{ translate?.SECTION_C.DESCRIPTION }}</mat-label>
              <textarea matInput rows="4" formControlName="productServiceDescription" (keypress)="allowAddressChars($event)" (paste)="allowEnglishPaste($event)"></textarea>

              <mat-error *ngIf="form.get('productServiceDescription')?.touched &&
                        form.get('productServiceDescription')?.hasError('required')">
                {{translate?.ProductDescRequired}}
              </mat-error>
            </mat-form-field>
          </div>

          <div class="col-m-12">
            <!-- Unique Selling Points -->
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>{{ translate?.SECTION_C.USP }}</mat-label>
              <textarea matInput rows="4" formControlName="uniqueSellingPoints" (keypress)="allowAddressChars($event)" (paste)="allowEnglishPaste($event)"></textarea>
              <mat-error *ngIf="form.get('uniqueSellingPoints')?.touched &&
                        form.get('uniqueSellingPoints')?.hasError('required')">
                {{translate?.UniqueSellingRequired}}
              </mat-error>
            </mat-form-field>
          </div>

          <!-- Target Market -->
          <div class="col-m-12">
            <div class="radio-group">
              <mat-label matInput class="radio-label">{{ translate?.SECTION_C.MARKET }}*</mat-label>

              <mat-radio-group formControlName="targetMarket" class="radio-row">
                <mat-radio-button value="D">{{ translate?.MARKET.DOM }}</mat-radio-button>
                <mat-radio-button value="I">{{ translate?.MARKET.INT }}</mat-radio-button>
                <mat-radio-button value="B">{{ translate?.MARKET.BOTH }}</mat-radio-button>
              </mat-radio-group>

              <mat-error *ngIf="form.get('targetMarket')?.touched &&
                        form.get('targetMarket')?.hasError('required')">
                <small>{{translate?.TargetMarketRequired}}</small>
              </mat-error>
            </div>
          </div>
        </div>
      </section>

      <!-- ================= SECTION D ================= -->
      <section class="section">
        <h2 class="eoi-exhibition">{{ translate?.SECTION_D.TITLE}}</h2>
        <div class="row px-3">

          <div class="col-md-6">
            <div class="radio-group">
              <mat-label class="radio-label">{{ translate?.SECTION_D.PREV }}*</mat-label>
              <mat-radio-group formControlName="participatedInExhibition">
                <mat-radio-button value="Y">{{ translate?.YES }}</mat-radio-button>
                <mat-radio-button value="N">{{ translate?.NO }}</mat-radio-button>
              </mat-radio-group>
              <mat-error *ngIf="form.get('participatedInExhibition')?.hasError('required')">
                <small>{{translate?.ParticipatedExhibitionRequired}}</small>
              </mat-error>
            </div>
          </div>

          <div class="col-md-12">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>{{ translate?.SECTION_C.DESCRIPTION }}</mat-label>
              <textarea matInput rows="4" formControlName="exhibitionDetails" (keypress)="allowAddressChars($event)" (paste)="allowEnglishPaste($event)"></textarea>

              <mat-error *ngIf="form.get('exhibitionDetails')?.touched &&
                  form.get('exhibitionDetails')?.hasError('required')">
                {{translate?.ExhibitionDetailsRequired}}
              </mat-error>
            </mat-form-field>
          </div>

          <div class="col-md-6 mb-3">
            <div class="radio-group">
              <label class="radio-label">{{ translate?.SECTION_D.TYPE}}*</label>
              <mat-radio-group formControlName="preferredExhibitionType">
                <mat-radio-button value="STATE">{{ translate?.EXHIBITION.STATE }}</mat-radio-button>
                <mat-radio-button value="NATIONAL">{{ translate?.EXHIBITION.NATIONAL }}</mat-radio-button>
                       <mat-radio-button value="INTERNATIONAL">
        {{ translate?.EXHIBITION.INTERNATIONAL }}
      </mat-radio-button>

              </mat-radio-group>
              <mat-error *ngIf="form.get('preferredExhibitionType')?.hasError('required')">
                <small>{{translate?.PreferredExhibitionTypeRequired}}</small>
              </mat-error>
            </div>
          </div>

          <div class="col-md-12">
            <div class="radio-group">
              <label class="radio-label">{{ translate?.SECTION_D.OBJECTIVE }}*</label>
              <mat-radio-group formControlName="objectiveID" class="radio-row">
                <mat-radio-button value="1">{{ translate?.OBJECTIVE.PROMO}}</mat-radio-button>
                <mat-radio-button value="2">{{ translate?.OBJECTIVE.NET }}</mat-radio-button>
                <mat-radio-button value="3">{{ translate?.OBJECTIVE.BUSINESS }}</mat-radio-button>
                <mat-radio-button value="4">{{ translate?.OBJECTIVE.EXPORT }}</mat-radio-button>
              </mat-radio-group>
              <mat-error *ngIf="form.get('objectiveID')?.hasError('required')">
                <small>{{translate?.ObjectiveNameRequired}}</small>
              </mat-error>
            </div>
          </div>
        </div>
      </section>

      <!-- ================= SECTION E ================= -->
      <section class="section">
        <h2 class="eoi-exhibition">{{ translate?.SECTION_E.TITLE }}</h2>
        <div class="row mb-3 px-3">
          <div class="col-md-6">
            <label class="file-label">{{ translate?.SECTION_E.VIDEO }}*</label>
            <input type="file" formControlName="VideoFile"
                   accept="video/*"
                   (change)="onVideoChange($event)" class="form-control">

            <mat-error *ngIf="form.get('VideoFile')?.touched && form.get('VideoFile')?.hasError('required')">
              <small>{{translate?.VideoFileRequired}}</small>
            </mat-error>

            <mat-error *ngIf="videoDurationError">
              <small>Video duration must be between 10 to 20 seconds.</small>
            </mat-error>
          </div>

          <div class="col-md-6">
            <label class="file-label">{{ translate?.SECTION_E.PHOTOS }}*</label>
            <input type="file" formControlName="PhotoFile"
                   multiple
                   accept=".jpeg,.jpg"
                   (change)="onPhotoChange($event)" class="form-control" />

            <mat-error *ngIf="form.get('PhotoFile')?.touched && form.get('PhotoFile')?.hasError('required')">
              <small>{{translate?.PhotoRequired}}</small>
            </mat-error>
          </div>
        </div>
      </section>

      <!-- ================= SECTION F ================= -->
      <section class="section">
        <h2 class="eoi-exhibition">{{ translate?.SECTION_F?.TITLE }}</h2>
        <div class="row px-3">
          <div class="col-md-6">
            <div class="radio-group">
              <label class="radio-label">{{ translate?.SECTION_F.SUPPORT}}*</label>
              <mat-radio-group formControlName="requireGovernmentSupport">
                <mat-radio-button value="Y">{{ translate?.YES }}</mat-radio-button>
                <mat-radio-button value="N">{{ translate?.NO }}</mat-radio-button>
              </mat-radio-group>
              <mat-error *ngIf="form.get('requireGovernmentSupport')?.hasError('required')">
                <small>{{translate?.GovernmentSupportRequired}}</small>
              </mat-error>
            </div>
          </div>

          <div class="col-md-6 px-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>{{ translate?.SECTION_F.ASSISTANCE}}</mat-label>
              <textarea matInput formControlName="specificAssistanceRequired" (keypress)="allowAddressChars($event)" (paste)="allowEnglishPaste($event)"></textarea>
              <mat-error *ngIf="form.get('specificAssistanceRequired')?.hasError('required')">
                {{translate?.SpecificAssistanceRequired}}
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </section>

      <!-- ================= SECTION G ================= -->
      <section class="section">
        <h2 class="eoi-exhibition">{{ translate?.SECTION_G.TITLE }}</h2>
        <div class="row px-3">
          <div class="col-md-12">
            <mat-checkbox formControlName="declarationAccepted">
              {{ translate?.SECTION_G.TEXT}}
            </mat-checkbox>

            <mat-error *ngIf="form.get('declarationAccepted')?.touched &&
                      form.get('declarationAccepted')?.hasError('requiredTrue')">
              {{translate?.SubmitRequired}}
            </mat-error>
          </div>
        </div>
        <div class="row px-3">
          <div class="col-md-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>{{ translate?.SECTION_G.NAME}}</mat-label>
              <input matInput (input)="onAuthorizedSignatoryNameInput($event)" formControlName="authorizedSignatoryName" (keypress)="allowEnglishAndNumbers($event)" (paste)="allowEnglishPaste($event)">
              <mat-error *ngIf="form.get('authorizedSignatoryName')?.hasError('required')">
                {{translate?.SignatoryNameRequired}}
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-md-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>{{ translate?.SECTION_G.DESIGNATION }}</mat-label>
              <input matInput (input)="onAuthorizedSignatoryDesignationInput($event)" formControlName="authorizedSignatoryDesignation" (keypress)="allowEnglishAndNumbers($event)" (paste)="allowEnglishPaste($event)">
              <mat-error *ngIf="form.get('authorizedSignatoryDesignation')?.hasError('required')">
                {{translate?.SignatoryDesignationRequired}}
              </mat-error>
            </mat-form-field>
          </div>

          <div class="col-md-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>{{ translate?.SECTION_G.DATE }}</mat-label>

              <input matInput
                     formControlName="declarationDate"
                     [matDatepicker]="picker"
                     [max]="today" />

              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>

              <mat-error *ngIf="form.get('declarationDate')?.touched && form.get('declarationDate')?.hasError('required')">
                {{ translate?.DateRequired }}
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </section>

      <div class="text-center" *ngIf="form.get('declarationAccepted')?.value">
        <button mat-flat-button type="submit" class="btn btn-theme2 square-btn">
          {{ translate?.SUBMIT }}
        </button>
      </div>
    </div>
  </div>
</form>



